module.exports = __webpack_public_path__ + "img/item-info-icon4.895f3397.svg";